import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Button = styled.button`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  width: 34px;
  height: 100%;
  padding: 0;
  cursor: pointer;
  border: none;
  border-radius: 6px 0 0 6px;
  background: #f2f2f2;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.6;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  ${({ theme }) => css`
    ${theme?.uploadButton?.styles}
  `}
`;

export const HiddenInput = styled.input`
  display: none;
`;
